import { useState } from "react";
import { ChevronDown, Check, AlertCircle } from "lucide-react";
import { MODELS } from "../lib/models";
import { Markdown } from "./Markdown";

const StatusIcon = ({ status, color }) => {
  if (status === "done") return <Check size={13} style={{ color }} />;
  if (status === "error") return <AlertCircle size={13} className="text-red-400" />;
  return <span className="what-pulse" style={{ background: color }} />;
};

const SourceCard = ({ m, text, status, prefix }) => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={`${prefix}-card-${m.testid}`} className="what-source" style={{ "--c": m.color }}>
      <button data-testid={`toggle-${prefix}-${m.testid}`} onClick={() => setOpen(!open)} className="w-full flex items-center gap-3 px-4 py-3 text-left">
        <span data-testid={`${prefix}-status-${m.testid}`} className="w-4 flex justify-center"><StatusIcon status={status} color={m.color} /></span>
        <span className="font-display font-semibold text-sm text-white">{m.name}</span>
        <span className="text-xs font-mono" style={{ color: m.color }}>{m.version}</span>
        <span className="ml-auto text-xs text-slate-500 font-mono">
          {status === "error" ? "failed" : status === "done" ? `${text.split(/\s+/).filter(Boolean).length} words` : "thinking…"}
        </span>
        <ChevronDown size={15} className={`text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-5 pb-5 pt-1 border-t border-white/[0.05] text-sm">
          {text ? <Markdown testid={`${prefix}-answer-${m.testid}`}>{text}</Markdown> : <p className="text-slate-500">No response.</p>}
        </div>
      )}
    </div>
  );
};

export const ModelSources = ({ answers, statuses, models, prefix = "model", testid = "per-model-accordion" }) => (
  <div data-testid={testid} className="grid gap-2">
    {MODELS.filter((m) => models.includes(m.key)).map((m) => (
      <SourceCard key={m.key} m={m} prefix={prefix} text={answers?.[m.key] || ""} status={statuses?.[m.key] || (answers?.[m.key] ? "done" : "error")} />
    ))}
  </div>
);
